import { useRightPanel } from 'hooks/useRightPanel'

import { useActionless } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import CollapsibleContentContainer from 'components/elements/CollapsibleContentContainer'
import ColorProductionVsGeneration from 'components/deckPage/charts/ColorProductionVsGeneration'
import StatsContainerCardList from 'components/deckPage/StatsContainer/StatsContainerCardList'
import Probability from '../RightPanel/Probability'
import ManaCurves from '../charts/ManaCurves'
import QuantitiyTables from '../charts/QuantityTables'
import StickiedDeckControls from '../filtersAndControls/StickiedDeckControls'
import PhatButton from 'components/formElements/PhatButton'

import styles from './statsContainer.module.scss'

const StatsContainer = () => {
  const [rightPanelStatus, setRightPanelStatus] = useRightPanel()
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  return (
    <CollapsibleContentContainer name="Color info" className={styles.container}>
      <div className={styles.header}>
        <h2>Deck stats</h2>

        <div>
          <PhatButton icon="fire" onClick={() => setActiveState({ autofillBasicLandsOverlay: true })}>
            Basic land optimizer
          </PhatButton>

          <PhatButton
            className={styles.pinStatsButton}
            icon="columns"
            onClick={() => setRightPanelStatus({ ...rightPanelStatus, locked: !rightPanelStatus.locked })}>
            {rightPanelStatus.locked ? 'Unpin' : 'Pin'} stats above
          </PhatButton>
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.visualizations}>
          <ColorProductionVsGeneration />
          <ManaCurves neverHideCharts tallerPrimaryChart />
          <Probability />
          <QuantitiyTables />
        </div>
        <StickiedDeckControls liteControls />
        <div className={styles.cardList}>
          <StatsContainerCardList />
        </div>
      </div>
    </CollapsibleContentContainer>
  )
}

export default StatsContainer
